import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Paper, Tabs, Tab } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import type { Theme } from '@mui/material/styles'
import {
  AdminSideBarRouteProps,
  TabMenuItemLabels,
} from '../partials/AdminSidebar'

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
  },
  selected: {
    fontWeight: 600,
  },
}))

export type TabPanelProps = {
  label: TabMenuItemLabels
  value: string
}

export type NavTabsProps = {
  tabs: Array<TabPanelProps>
  onSelect: (name: string) => void
  current: string
}

const NavTabs: React.FC<NavTabsProps> = ({
  tabs,
  onSelect,
  current,
}: NavTabsProps) => {
  const { t } = useTranslation()
  const { classes, cx } = useStyles()
  const [currentTab, setCurrentTab] = useState(current)
  const handleChange = (
    event: React.ChangeEvent<{}>,
    newValue: AdminSideBarRouteProps
  ) => {
    setCurrentTab(newValue)
    // NOTE: タブが切り替わるアニメーションを待つ
    setTimeout(() => {
      onSelect(newValue)
    }, 300)
  }

  return (
    <Paper square className={classes.root}>
      <Tabs
        variant="fullWidth"
        value={currentTab}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
      >
        {tabs.map((tab) => (
          <Tab
            key={`tab-${tab.value}`}
            {...tab}
            label={t(tab.label)}
            className={cx(currentTab === tab.value && classes.selected)}
          />
        ))}
      </Tabs>
    </Paper>
  )
}

export default NavTabs
